import React from "react";
import PropTypes from "prop-types";
import GridRow from "./GridRow";

const GridRowExpandable = props => {
  const {
    style = {},
    checkRowSelected = () => undefined,
    onRowSelectChange = () => undefined,
    checkboxDisabled = false,
    checkCheckboxVisible = () => true,
    expanded = false,
    onRowExpandedChange = () => undefined,
    checkRowExpanded = () => undefined,
    renderExpandedRow = () => undefined,
    rowClassName = () => "",
    rowItem,
    rowIndex,
    expandedRowColumns = 10
  } = props;

  const isExpanded = checkRowExpanded(rowItem, rowIndex);

  return (
    <GridRow
      {...props}
      checkRowSelected={checkRowSelected}
      onRowSelectChange={onRowSelectChange}
      checkboxDisabled={checkboxDisabled}
      checkCheckboxVisible={checkCheckboxVisible}
      expanded={expanded}
      style={style}
      onClick={e => {
        const withExpandCell =
          rowClassName() === "row-expandable-with-expand-cell";
        if (e.target.skipRowClick) {
          return;
        }
        if (
          withExpandCell &&
          !e.target.classList.contains("row-expandable__expand-cell") &&
          !e.target.classList.contains("row-expandable__expand-cell-icon")
        ) {
          return;
        }
        onRowExpandedChange(!isExpanded, rowItem, rowIndex);
      }}
      className={`${rowClassName ? rowClassName(rowItem) : ""}${
        isExpanded ? " state-expanded" : ""
      } row-expandable`}
    >
      {isExpanded && (
        <tr className="expanded-row">
          <td colSpan={expandedRowColumns}>
            <div>{renderExpandedRow(rowItem, rowIndex)}</div>
          </td>
        </tr>
      )}
    </GridRow>
  );
};

GridRowExpandable.propTypes = {
  ...GridRow.propTypes,
  expanded: PropTypes.bool,
  onRowExpandedChange: PropTypes.func,
  checkRowExpanded: PropTypes.func,
  renderExpandedRow: PropTypes.func,
  expandedRowColumns: PropTypes.number,
  rowClassName: PropTypes.func
};

export default GridRowExpandable;
